/**
 * @param onClicked {(cta: HTMLElement, marketoFormId: string) => void}
 * @return {void}
 */
module.exports = function listenToRoiCalculatorReturningUserCtaClicks(onClicked) {
    document.querySelectorAll('[data-component="returning-user-cta"]').forEach(returningUserCta => {
        if (returningUserCta instanceof HTMLElement) {
            returningUserCta.addEventListener("click", e => {
                e.preventDefault();

                const marketoFormId = returningUserCta.getAttribute("data-marketoFormId");

                onClicked(e.currentTarget, marketoFormId);
            });
        }
    });
}